<template>
  <div>
    <section class="mb-4 d-flex align-center">
      <h3 v-t="'page.account.trades'" class="text-h5 text-uppercase font-weight-extrabold" />
      <v-spacer />
      <v-btn
        color="grey300"
        tile small class="unwidth"
        :ripple="false" :loading="loading.trades"
        @click="getPendingTrades"
      >
        <fai :icon="['fas','sync']" class="grey100--text" />
      </v-btn>
    </section>

    <section>
      <v-card
        v-for="trade in pendingTrades"
        :key="trade.id"
        tile color="grey500"
        class="mb-4"
      >
        <div class="header pa-5 d-flex align-center justify-space-between">
          <div>
            <h3 class="text-body-1 blue200--text font-weight-bold text-capitalize">
              {{ trade.type }} Trade Offer
            </h3>
            <h4 class="text-caption grey200--text">
              {{ trade.id }} ({{ trade.statusText }})
            </h4>
          </div>

          <!-- trade offer button -->
          <v-btn
            v-if="trade.isSending || trade.isActive"
            depressed
            color="blue700"
            class="blue200--text rounded-0 font-weight-semibold"
            :ripple="false"
            rel="noopener noreferrer"
            target="_blank"
            :loading="trade.isSending"
            :href="trade.tradeOfferUrl"
          >
            <fai :icon="['fab', 'steam']" class="mr-2" />
            <span v-t="'page.account.trades.cta.open'" />
          </v-btn>

          <v-btn
            v-else-if="trade.canResend"
            depressed
            color="primary700"
            class="primary200--text rounded-0 font-weight-semibold"
            :ripple="false"
            :loading="loading.resend"
            @click="onResend(trade.id)"
          >
            <fai :icon="['fad', 'sync']" class="mr-2" />
            <span v-t="'page.account.trades.cta.resend'" />
          </v-btn>
        </div>

        <div v-if="trade.items.length" class="grey600 d-flex flex-wrap px-4 py-3">
          <GameItem
            v-for="(item, i) in toItems(trade.items)" :key="i"
            :item="item"
            no-item-color
            :size="40"
            class="mr-2"
          />
        </div>

        <div v-if="trade.error && !trade.isActive" class="primary900 text-body-2 px-4 py-2 primary300--text">
          Error: {{ trade.errorText }} ({{ trade.error }})
        </div>
      </v-card>

      <span v-if="!pendingTrades.length" v-t="'page.account.trades.no_trades'" class="text--secondary" />
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: {
        trades: false,
        resend: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
      pendingTrades: 'user/pendingTrades',
      itemdb: 'items/items',
    }),
  },
  created() {
    this.getPendingTrades()
  },
  methods: {
    ...mapActions({
      _getPendingTrades: 'user/getPendingTrades',
    }),
    toItems(items) {
      const { itemdb } = this
      return items.map(i => ({ ...itemdb[i.name] }))
    },
    async getPendingTrades() {
      this.loading.trades = true

      try {
        await this._getPendingTrades()
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading.trades = false
      }
    },
    async onResend(id) {
      this.loading.resend = true

      try {
        await this.$socket.request('user.inventory.withdraw.resend', id)

        this.$toast.success(this.$t('page.shop.notification.withdraw'))
      } catch (error) {
        this.$toast.error(error.message)
      } finally {
        this.loading.resend = false
      }
    },
  },
}
</script>
